/* eslint-disable import/prefer-default-export */
import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@blueprintjs/core';
import { Classes, Tooltip2 } from '@blueprintjs/popover2';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { DomainFormItem } from '../hooks/useDomainForm';

type ActionCellRendererProps = {
  context: {
    domainNames: DomainFormItem[],
    onClickRemoveDomainItem: (domain: DomainFormItem) => void
  }
} & ICellRendererParams

export const ActionCellRenderer: FC<ActionCellRendererProps> = ({ data, context }) => {
  return <Button icon="trash" minimal onClick={() => context.onClickRemoveDomainItem(data)} />
}

export const DomainNameCellRenderer: FC<ICellRendererParams> = (props) => {
  const { t } = useTranslation();
  const { rowIndex, value, context } = props;
  const tutorialIndex = context.domainNames.findIndex(({ domainName } : DomainFormItem) => domainName === '');
  const [isOpen, setIsOpen] = useState(tutorialIndex === rowIndex);

  useEffect(() => {
    if (isOpen){
      setTimeout(() => setIsOpen(false), 1500)
    }
  }, [isOpen]);

  if (value){
    return <span>{value}</span>
  }

  return (
    <Tooltip2
      compact
      intent="danger"
      isOpen={isOpen}
      className={Classes.TOOLTIP2_INDICATOR}
      content={(<span>{t('sipSetting.grid.prefixRequired')}</span>)}
    >
      <Icon
        icon="error"
        intent="danger"
        iconSize={12}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      />
    </Tooltip2>
  );
}
